import React, {useRef} from 'react'
import {googleLogout} from '@react-oauth/google';
import {useSolv} from "./components/SolvProvider"
import {useIntlEx} from "./components/IntlUtils.js"
import {Anchor, AppLogo, DropdownMenuDivider, DropdownMenuItem} from "./components/FormComps";
import {AboutSolvDialog} from './AboutSolvDialog.js'
import {PlaceholderImage} from "./components/ImageUtils";
import getLogger from "./components/Logging.js"
import './App.css'
import {mkBrandName} from "./components/Utils";

const log = getLogger("MainMenu")

export default function MainMenu(props) {

  const {env, session, signout, setBusy} = useSolv()
  const {intl } = useIntlEx()

  // const [tenant, setTenant] = useState(null)

  // const { width, height, ref } = useResizeDetector()
  const homeLinkRef = useRef()

  // useEffect(() => {
  //   if (props) {
  //     // log.debug(">>>Z: props.tenant=", props.tenant)
  //     setTenant(props.tenant)
  //   }
  // },[])

  function handleSignout() {
    setBusy(intl.msg("working"))
    signout()
      .then((data) => {
        // // log.debug("handleSignout: data=", data)
        googleLogout()
      })
      .catch((err) => {
        log.error(err)
      })
      .finally(() => {
        setBusy(null)
      })
  }

  // useEffect(() => {
  //   document.querySelector(':root').style.setProperty("--main-menu-height", height)
  // }, [height])

  return (
    <>
      <nav className="main-menu">
      {/*<nav ref={ref} className="main-menu fixed-top">*/}
        {
          <>
            <div className="items">

              <ul className="items" style={{flex: "1", justifyContent: "left"}}>

                <li className="brand-item">
                  <Anchor ref={homeLinkRef} href="/" activeClassName="brand-link-active" user={session.user} tenant={props.tenant} match="EXACT" title={intl.msg("home")}>
                    <AppLogo height="14" place="menu"/>
                  </Anchor>
                </li>

                {
                  session.user && props.tenant &&
                    <>
                      {
                        session.user.isReporterOrAbove() && (session.user.isSystem() || session.user.isReseller()) &&
                          <li className="menu-item">
                            <Anchor href="/clients" user={session.user} tenant={props.tenant}>
                              {intl.msg("clients")}
                            </Anchor>
                          </li>
                      }

                      {
                        session.user.isReporterOrAbove() && (session.user.isSystem() || (session.user.isReseller() && session.tenant?.hasSubTenants())) &&
                          <li className="menu-item">
                            <Anchor href="/resellers" user={session.user} tenant={props.tenant}>
                              {intl.msg("resellers")}
                            </Anchor>
                          </li>
                      }

                      {
                        session.user.isReporterOrAbove() && session.user.isSystem() &&
                          <li className="menu-item">
                            <Anchor href="/affiliates" user={session.user} tenant={props.tenant}>
                              {intl.msg("affiliates")}
                            </Anchor>
                          </li>
                      }

                      {
                        session.user.isReporterOrAbove() && (session.user.isClient() || session.user.isReseller() || session.user.isSystem()) &&
                          <li className="menu-item">
                            <Anchor href="/broadcasts" user={session.user} tenant={props.tenant}>
                              {intl.msg("broadcasts")}
                            </Anchor>
                          </li>
                      }

                      {
                        session.user.isReporterOrAbove() &&
                          <li className="menu-item">
                            <Anchor href="/members" user={session.user} tenant={props.tenant}>
                              {intl.msg("members")}
                            </Anchor>
                          </li>
                      }

                      {
                        session.user.isReporterOrAbove() && (session.user.isClient() || session.user.isReseller() || session.user.isSystem()) &&
                          <li className="menu-item">
                            <Anchor href="/credits" user={session.user} tenant={props.tenant}>
                              {intl.msg("credits")}
                            </Anchor>
                          </li>
                      }

                      {/*{*/}
                      {/*  user && user.isOperatorOrAbove() && user.isReseller() &&*/}
                      {/*    <>*/}
                      {/*      <li className="menu-item">*/}
                      {/*        <Anchor href="/refcodes" user={user} tenant={tenant}>*/}
                      {/*          {intl.msg("refcodes")}*/}
                      {/*        </Anchor>*/}
                      {/*      </li>*/}
                      {/*    </>*/}
                      {/*}*/}

                      {/*{*/}
                      {/*  user && user.isOperatorOrAbove() && (user.isSystem() || user.isReseller()) &&*/}
                      {/*    <>*/}
                      {/*      <li className="menu-item">*/}
                      {/*        <Anchor href="/income" user={user} tenant={tenant}>*/}
                      {/*          {intl.msg("revenue")}*/}
                      {/*        </Anchor>*/}
                      {/*      </li>*/}
                      {/*    </>*/}
                      {/*}*/}

                      {
                        session.user.isReporterOrAbove() && (session.user.isAffiliate() || session.user.isReseller() || session.user.isSystem()) &&
                          <li className="menu-item">
                            <Anchor href="/commissions" user={session.user} tenant={props.tenant}>
                              {intl.msg("commissions")}
                            </Anchor>
                          </li>
                      }
                      {
                        session.user.isSystem() && session.user.isReporterOrAbove() &&
                          <>

                            <li className="menu-item">
                              <span style={{color: "var(--menu-border-color)"}}>|</span>
                            </li>

                            <li className="menu-item">
                              <Anchor href="/sys/bankaccounts" user={session.user} tenant={props.tenant}>
                                {intl.msg("bank_accounts")}
                              </Anchor>
                            </li>

                            <li className="menu-item">
                              <Anchor href="/sys/countries" user={session.user} tenant={props.tenant}>
                                {intl.msg("countries")}
                              </Anchor>
                            </li>

                            <li className="menu-item">
                              <Anchor href="/sys/currencies" user={session.user} tenant={props.tenant}>
                                {intl.msg("currencies")}
                              </Anchor>
                            </li>

                            {/*<li className="menu-item">*/}
                            {/*  <Anchor href="/sys/industries" user={session.user} tenant={props.tenant}>*/}
                            {/*    {intl.msg("industries")}*/}
                            {/*  </Anchor>*/}
                            {/*</li>*/}

                            <li className="menu-item">
                              <Anchor href="/sys/locations" user={session.user} tenant={props.tenant}>
                                {intl.msg("locations")}
                              </Anchor>
                            </li>

                            <li className="menu-item">
                              <Anchor href="/sys/props" user={session.user} tenant={props.tenant}>
                                {intl.msg("props")}
                              </Anchor>
                            </li>

                            <li className="menu-item">
                              <Anchor href="/sys/regions" user={session.user} tenant={props.tenant}>
                                {intl.msg("regions")}
                              </Anchor>
                            </li>

                            <li className="menu-item">
                              <Anchor href="/sys/signupRequests" user={session.user} tenant={props.tenant}>
                                {intl.msg("signup_requests")}
                              </Anchor>
                            </li>

                            <li className="menu-item">
                              <Anchor href="/sys/versions" user={session.user} tenant={props.tenant}>
                                {intl.msg("versions")}
                              </Anchor>
                            </li>
                          </>
                      }

                    </>
                }

              </ul>

              {/*{*/}
              {/*  user && user.isReporterOrAbove()() && user.isSystem() &&*/}
              {/*    <li className="menu-item tools-item">*/}
              {/*      <a href="/sys" title={intl.msg("system_tooltip")}>*/}
              {/*        <div className="round-item">*/}
              {/*          <i className="fas fa-skull" style={{fontSize: "8pt"}}></i>*/}
              {/*        </div>*/}
              {/*      </a>*/}
              {/*    </li>*/}
              {/*}*/}

              <ul className="items">
                <li className="menu-item help-item">
                  <a href="#" className="dropdown-toggle dropdown-caret-off"  title={intl.msg("help_tooltip")} data-toggle="dropdown" data-offset="0,2" aria-haspopup="true" aria-expanded="false">
                    <div className="round-item">
                      ?
                    </div>
                  </a>
                  <div className="dropdown-menu" aria-labelledby="mni_help">
                    {/*<a className="dropdown-item" href="/whatsnew">{intl.msg("whats_new")}</a>*/}
                    {/*<div className="dropdown-divider"></div>*/}
                    {/*<a className="dropdown-item" href="https://help.solv.technology/category/using-solv" target="_blank">{intl.msg("hc_using_solv")}</a>*/}
                    {/*<a className="dropdown-item" href="https://help.solv.technology/category/faq" target="_blank">{intl.msg("hc_faq")}</a>*/}
                    <a className="dropdown-item" href="mailto:support@solv.technology" target="_blank">{intl.msg("hc_help_contact_support")}</a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="#" data-toggle="modal" data-target="#dlg_about_solv">
                      <span className="mr-1">
                        {intl.msg("about_app", {appName: mkBrandName(env.brandName, props.tenant?.cobrand?.brandName)})}
                      </span>
                    </a>
                  </div>
                </li>

                <li className="menu-item user-item">
                  <a href="#" className="dropdown-toggle dropdown-caret-off"  title={session.user?.displayName} data-toggle="dropdown" data-offset="0,2" aria-haspopup="true" aria-expanded="false">
                    <div className="round-item">
                      {
                        session.user?.imageUrl ? (
                          <img src={session.user.imageUrl} style={{width: "18px", height: "18px", borderRadius: "50%"}}/>
                        ) : (
                          <div style={{marginTop: "-2px"}}>
                            <PlaceholderImage icon="person" width="16" height="16" borderRadius="50%"/>
                          </div>
                        )
                      }
                    </div>
                  </a>
                  <div className="dropdown-menu" aria-labelledby="mni_user">
                    <DropdownMenuItem name="profile" href="/me"/>
                    {/*<a className="dropdown-item" href="/me">*/}
                    {/*  {intl.msg("profile")}*/}
                    {/*</a>*/}
                      {/*<span>{intl.msg("profile")}:</span>*/}
                      {/*<span className="ml-1 text-muted">{user?.displayName}</span></a>*/}
                    <DropdownMenuDivider/>
                    <DropdownMenuItem name="signout" onClick={handleSignout}/>
                    {/*<a className="dropdown-item" href="#" onClick={handleSignout}>*/}
                    {/*  {intl.msg("signout")}*/}
                    {/*</a>*/}
                  </div>
                </li>
              </ul>
            </div>
          </>
        }
      </nav>
      {/*<div className="main-menu-push" style={{height: height}}></div>*/}
      <AboutSolvDialog/>
    </>
  )
}
